const locale = {
  APOLLO_ERROR_TITLE: 'Something went wrong with the server',
  APOLLO_ERROR_DESCRIPTION: 'Please try again later',
  CLOSE_NOTIFICATION_ARIA_LABEL: 'Close notification',
};

export default locale;
